import api from "@utils/api.client"

export interface PortalNotification {
  id?: string
  _id?: string
  title: string
  body: string
  href: string
  readAt?: string | null
  createdAt: string
}

export const notificationsApi = {
  async list() {
    const response = await api.get<PortalNotification[]>("/notifications")
    return response.data
  },
  async markRead(id: string) {
    await api.patch(`/notifications/${id}/read`, {})
  },
  async markAllRead() {
    await api.patch("/notifications/read-all", {})
  },
}
